export default function EventCardSkeleton({ isMobile = false }) {
  return (
    <div
      className={`bg-white rounded-lg shadow-sm border overflow-hidden animate-pulse ${
        isMobile ? "flex-shrink-0 min-w-[220px]" : "mb-4"
      }`}
    >
      {/* Image skeleton */}
      <div className="w-full h-40 bg-gray-200"></div>

      {/* Content skeleton */}
      <div className="p-4">
        {/* Category badge skeleton */}
        <div className="h-6 bg-gray-200 rounded-full w-20 mb-2"></div>

        {/* Title skeleton */}
        <div className="h-5 bg-gray-200 rounded w-full mb-2"></div>
        <div className="h-5 bg-gray-200 rounded w-2/3 mb-3"></div>

        {/* Description skeleton */}
        <div className="h-4 bg-gray-200 rounded w-full mb-1"></div>
        <div className="h-4 bg-gray-200 rounded w-3/4 mb-3"></div>

        {/* Date and time skeleton */}
        <div className="flex items-center space-x-4 mb-3">
          <div className="h-4 bg-gray-200 rounded w-16"></div>
          <div className="h-4 bg-gray-200 rounded w-20"></div>
        </div>

        {/* Location skeleton */}
        <div className="h-4 bg-gray-200 rounded w-24 mb-3"></div>

        {/* Button skeleton */}
        <div className="h-8 bg-gray-200 rounded w-full"></div>
      </div>
    </div>
  );
}
